import React from "react";
import { Redirect } from "react-router-dom";
import { BarLoader } from "react-spinners";

export default function() {
  const { username, password, loggedIn, loggingIn } = this.state;
  return (
    <div className="container splash">
      {loggedIn && <Redirect to="/machines" />}
      <img src="logo-large.png" className="splash-logo" alt="RugDoctor" />
      <input
        onChange={this._change("username")}
        value={username}
        placeholder="Username"
      />
      <input
        onChange={this._change("password")}
        value={password}
        type="password"
        placeholder="Password"
      />
      <button onClick={this._login}>
        {loggingIn ? (
          <div className="button-loader">
            <BarLoader width={200} height={4} color={"white"} />
          </div>
        ) : (
          "Submit"
        )}
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/login/view.js